function r(c, n = [], o) {
  const e = {};
  return n.forEach((t) => {
    e[t] = c[t];
  }), Object.assign(e, o);
}
export {
  r as keep
};
